<template>
  <a-modal
    title="资金流水详情"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    width="800px"
  >
    <a-descriptions :column="2" bordered>
      <a-descriptions-item label="流水ID">
        {{ detailData.id }}
      </a-descriptions-item>
      <a-descriptions-item label="条数">
        {{ detailData.serialNumber }}
      </a-descriptions-item>
      <a-descriptions-item label="变更类型">
        <a-tag :color="getChangeTypeColor(detailData.changeType)">
          {{ getChangeTypeText(detailData.changeType) }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="变更金额">
        <span
          :class="[
            'amount-text',
            detailData.changeAmount > 0 ? 'amount-positive' : 'amount-negative'
          ]"
        >
          {{ formatChangeAmount(detailData.changeAmount) }}
        </span>
      </a-descriptions-item>
      <a-descriptions-item label="手续费">
        <span class="fee-text">{{ formatAmount(detailData.fee) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="变更前余额">
        <span class="balance-text">{{ formatAmount(detailData.balanceBefore) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="变更后余额">
        <span class="balance-text">{{ formatAmount(detailData.balanceAfter) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="币种">
        {{ detailData.currency || 'INR' }}
      </a-descriptions-item>
      <a-descriptions-item label="订单ID" :span="2">
        <div class="order-info">
          <span>{{ detailData.orderNo }}</span>
          <CopyButton :text="detailData.orderNo" />
        </div>
      </a-descriptions-item>
      <a-descriptions-item label="商户订单ID" :span="2">
        <div class="order-info">
          <span>{{ detailData.mchOrderNo }}</span>
          <CopyButton :text="detailData.mchOrderNo" />
        </div>
      </a-descriptions-item>
      <a-descriptions-item label="订单时间" :span="2">
        {{ detailData.orderTime }}
      </a-descriptions-item>
      <a-descriptions-item label="创建时间" :span="2">
        {{ detailData.createdAt }}
      </a-descriptions-item>
      <a-descriptions-item label="更新时间" :span="2">
        {{ detailData.updatedAt }}
      </a-descriptions-item>
      <a-descriptions-item label="备注信息" :span="2">
        <div class="remark-content">
          {{ detailData.remark || '--' }}
        </div>
      </a-descriptions-item>
    </a-descriptions>

    <!-- 扩展信息 -->
    <a-divider>扩展信息</a-divider>
    <div v-if="detailData.extendInfo && Object.keys(detailData.extendInfo).length > 0">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item
          v-for="(value, key) in detailData.extendInfo"
          :key="key"
          :label="key"
        >
          <pre class="json-content">{{ formatJsonValue(value) }}</pre>
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <div v-else class="no-extend-info">
      <a-empty description="暂无扩展信息" />
    </div>
  </a-modal>
</template>

<script>
import CopyButton from '@/components/CopyButton/index'
import { formatAmount } from '@/utils/util'
import { getChangeTypeText, getChangeTypeColor } from '@/api/fundFlow'

export default {
  name: 'FundFlowDetailModal',
  components: {
    CopyButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 关闭弹窗
    handleCancel () {
      this.$emit('cancel')
    },

    // 格式化变更金额（显示正负号）
    formatChangeAmount (amount) {
      if (!amount && amount !== 0) return '--'
      const formattedAmount = formatAmount(Math.abs(amount))
      return amount >= 0 ? `+${formattedAmount}` : `-${formattedAmount}`
    },

    // 格式化JSON值
    formatJsonValue (value) {
      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2)
      }
      return value
    },

    // 格式化金额
    formatAmount,

    // 获取变更类型文本
    getChangeTypeText,

    // 获取变更类型颜色
    getChangeTypeColor
  }
}
</script>

<style lang="less" scoped>
.amount-text {
  font-weight: 500;

  &.amount-positive {
    color: #52c41a;
  }

  &.amount-negative {
    color: #ff4d4f;
  }
}

.fee-text {
  color: #fa8c16;
  font-weight: 500;
}

.balance-text {
  color: #1890ff;
  font-weight: 500;
}

.order-info {
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-family: 'Courier New', monospace;
    color: #666;
  }
}

.remark-content {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 100px;
  overflow-y: auto;
}

.json-content {
  white-space: pre-wrap;
  word-break: break-all;
  background-color: #f6f8fa;
  padding: 8px;
  border-radius: 4px;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

.no-extend-info {
  text-align: center;
  padding: 20px;
}

.ant-descriptions-item-label {
  font-weight: 500;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>
